import { REQUEST_FETCH_REGIONS, FETCH_REGIONS_SUCCESS, FETCH_REGIONS_ERROR } from './actionTypes';

export const requestFetchRegions = () => ({ type: REQUEST_FETCH_REGIONS });

export const fetchRegionsSuccess = listOfRegions => ({ type: FETCH_REGIONS_SUCCESS, payload: listOfRegions });

export const fetchRegionsError = () => ({ type: FETCH_REGIONS_ERROR });
